query UserApprovalSearch(
  $first: Int
  $after: Cursor
  $filter: UserApprovalFilter
  $isHistorySearch: Boolean
  $isQueuedSearch: Boolean
  $searchRequest: SearchRequestInput
  $orderBy: [UserApprovalsOrderBy!]
  $isLinkSearch: Boolean
) {
  userApprovalSearch(
    first: $first
    after: $after
    filter: $filter
    searchRequest: $searchRequest
    isHistorySearch: $isHistorySearch
    isQueuedSearch: $isQueuedSearch
    orderBy: $orderBy
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      entityId
      urgencyLevel
      _isUrgentApproval
      approvalTopic
      entityApprovalBranchId
      entityApprovalBranchRowTimestamp
      isLevelBypassingAllowed
      approvalPersona
      _isAccountingEntryStampedCompleted
      _isTransactionCancelled
      _accountingStampUserName
      _accountingStampDate
      _accountingStampTransactionReference
      additionalApprovalInformation
      _pendingApprovers
      userApprovalPhaseType {
        phaseName
      }

      userApprover {
        requesterDate
        requesterName
        approvedDate
        approvers
        rejectedDate
        rejectors
        amendedDate
        amendedByName
      }
      branchStatusType {
        approvalState
        statusType
      }
      iconType {
        iconType
        iconState
        isApprovalActionAvailable
      }
      companyCorporatePeriod {
        id
        _periodYear
      }
      description1
      description2
      description3
      description4
      description5
      date1
      amount1
       entityDocumentsByEntityId {
          nodes {
            id
            fileReference
            iconType
            _fileType
            fileIndexInformation
            comment
            documentTypes {
              documentType
            }
          }
        }
      currency {
        isoCode
      }
      businessUnit {
        name
      }
      department {
        name
      }
      _isValidating
      layoutType
      verificationLinkType {
        linkRouter
        linkHint
      }
      _isUserEnMasseApprovalAllowed
      isRequester
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
